export default __webpack_public_path__ + "static/media/47.5cda484e.jpg";